var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-attribute"},[_c('span',{class:{ highlighted: _vm.isHighlighted }},[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v(_vm._s(_vm.attribute.attributeString)+": "+_vm._s(_vm.attribute.attributeValueString))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }